import { Link } from 'react-router-dom';
import type { Order } from '@bharat-consultancy/shared';
import { StatusBadge } from '../ui/StatusBadge';

export function OrderCard({ order }: { order: Order }) {
  return (
    <Link
      to={`/dashboard/orders/${order.id}`}
      className="flex flex-col gap-3 rounded-lg border border-line bg-white p-5 transition-shadow hover:shadow-stamp sm:flex-row sm:items-center sm:justify-between"
    >
      <div>
        <p className="font-mono text-xs text-ink/50">{order.orderNumber}</p>
        <p className="mt-1 font-display text-base font-semibold text-ink">
          {order.service?.title ?? 'Service'}
        </p>
        <p className="mt-1 text-sm text-ink/60">{new Date(order.createdAt).toLocaleDateString('en-IN')}</p>
      </div>
      <div className="flex items-center gap-4">
        <span className="font-mono text-sm font-medium text-ink">₹{order.totalAmount.toLocaleString('en-IN')}</span>
        <StatusBadge status={order.status} />
      </div>
    </Link>
  );
}
